import React, { useState } from "react";
import { useSetting } from "../../context/SettingContext";
// import { defaultRingSize, reverseShowNums } from "../../constants/constants";
import MuiTextField from "./MuiTextField";

// import JS files

const RingNumbersEdit = (props) => {
  const { defaultRingSize, reverseShowNums } = useSetting();
  const check_is_disabled = (index) => {
    if (index == 0) {
      if (
        props.item.size_one_weight == "" ||
        props.item.size_one_weight == "0.0" ||
        props.item.size_one_weight == "0"
      )
        return true;
      return false;
    } else if (index == 1) {
      if (
        props.item.size_two_weight == "" ||
        props.item.size_two_weight == "0.0" ||
        props.item.size_two_weight == "0"
      )
        return true;
      return false;
    } else if (index == 2) {
      if (
        props.item.size_three_weight == "" ||
        props.item.size_three_weight == "0.0" ||
        props.item.size_three_weight == "0"
      )
        return true;
      return false;
    } else if (index == 3) {
      if (
        props.item.size_four_weight == "" ||
        props.item.size_four_weight == "0.0" ||
        props.item.size_four_weight == "0"
      )
        return true;
      return false;
    } else if (index == 4) {
      if (
        props.item.size_five_weight == "" ||
        props.item.size_five_weight == "0.0" ||
        props.item.size_five_weight == "0"
      )
        return true;
      return false;
    } else if (index == 5) {
      if (
        props.item.size_six_weight == "" ||
        props.item.size_six_weight == "0.0" ||
        props.item.size_six_weight == "0"
      )
        return true;
      return false;
    }
  };

  return (
    <>
      <div className="grid grid-cols-3 md:grid-cols-7 gap-y-2 md:gap-y-0">
        <div className="hidden md:block">
          {props.notShowTitle == undefined ? (
            <>
              <p className="text-center text-xs md:text-sm">سایز:</p>
            </>
          ) : (
            ""
          )}

          <p className=" text-center text-xs md:text-sm py-3">تعداد:</p>
        </div>
        {props.nums.map((item, index) => {
          console.log(reverseShowNums, defaultRingSize - index);
          if (defaultRingSize - index >= 0)
            return [
              <>
                <div className="mr-2">
                  {props.notShowTitle == undefined ? (
                    <p className=" text-center text-xs md:text-sm">
                      {(reverseShowNums ? defaultRingSize - index : index) + 1}
                    </p>
                  ) : (
                    ""
                  )}

                  <MuiTextField
                    autoFocus={
                      props.autoFocusFalse
                        ? false
                        : reverseShowNums
                        ? defaultRingSize + 1 - index
                        : index == 0
                        ? true
                        : false
                    }
                    tabIndex={`${
                      (reverseShowNums ? defaultRingSize - index : index) +
                      1 +
                      props.random_num
                    }`}
                    onChange={(e) =>
                      props.update_nums(
                        reverseShowNums ? defaultRingSize - index : index,
                        e.target.value
                      )
                    }
                    id="outlined-basic"
                    variant="outlined"
                    size="small"
                    // defaultValue={item}
                    value={
                      props.nums[
                        reverseShowNums ? defaultRingSize - index : index
                      ]
                    }
                    disabled={check_is_disabled(
                      reverseShowNums ? defaultRingSize - index : index
                    )}
                    isLTR={true}
                    placeholder={
                      check_is_disabled(
                        reverseShowNums ? defaultRingSize - index : index
                      ) && "غیر فعال"
                    }
                  />
                </div>
              </>,
            ];
        })}
      </div>
    </>
  );
};

export default RingNumbersEdit;
